import React, { useCallback, useRef, useEffect, useState } from "react";
import { renderToString } from "react-dom/server";
import { useParams } from "react-router-dom";

import styles from "./googleMap.module.css";
import { CloseImage, HistoryContextImage, MarkerGroup, PinSmallImage } from "../../assets/images/svg";
import { getYear } from "../Helpers/functions";

import { AdvancedMarker, APIProvider, Map, useApiIsLoaded, useMap } from "@vis.gl/react-google-maps";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import translation from "../Helpers/translation";

function GoogleMap({ data, mapLoaded, setMapLoaded, blur, setBlur, mapOptions }) {
    const [events, setEvents] = useState(null);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [wheelZoom, setWheelZoom] = useState(true)
    const { lang } = useParams()

    const changeZoom = () => {
        const list = document.getElementsByClassName(styles.popup);

        Array.from(list).forEach((item) => {
            item.classList.remove(styles.show);

            setTimeout(() => {
                item.parentElement.parentElement.parentElement.style.zIndex = "0";
            }, 100);
        });
    };

    useEffect(() => {
        if (data.events) {
            setBlur(true);

            setTimeout(() => {
                setEvents(null);

                setTimeout(() => {
                    const localEvents = [];
                    const tmp = [];

                    let mainIndex = 0;

                    data.events.forEach((item) => {
                        if (item.id === undefined && data.historyContext === "0") {
                            return null;
                        }
                        tmp.push([]);

                        if (Array.isArray(item.calendar_mastercategories) && item.calendar_mastercategories.length > 0) {
                            item.calendar_mastercategories.forEach((subItem) => {
                                if (!subItem || !Array.isArray(subItem.categories) || subItem.categories.length === 0) {
                                    return;
                                }
                                subItem.categories.forEach((subSubItem) => {
                                    if (!subSubItem || !Array.isArray(subSubItem.subcategories) || subSubItem.subcategories.length === 0) {
                                        return;
                                    }
                                    subSubItem.subcategories.forEach((subSubSubItem) => {
                                        if (!subSubSubItem || !Array.isArray(subSubSubItem.events) || subSubSubItem.events.length === 0) {
                                            return;
                                        }
                                        subSubSubItem.events.forEach((subSubSubSubItem) => {
                                            if (item.id) {
                                                subSubSubSubItem.localType = "composer";
                                                subSubSubSubItem.localData = {
                                                    firstName: item.first_name,
                                                    lastName: item.last_name,
                                                    image: item.image_avatar ? item.image_avatar : item.image,
                                                    id: item.id,
                                                    number: data.selectedCompositors.findIndex((compositor) => parseInt(compositor) === item.id) + 1,
                                                };
                                            } else {
                                                subSubSubSubItem.localType = "history";
                                                subSubSubSubItem.localData = { number: 5 };
                                            }

                                            const eventsTypes = Array.isArray(subSubSubSubItem.types_event)
                                                ? subSubSubSubItem.types_event
                                                    .map((event) => event?.id != null ? event.id.toString() : null)
                                                    .filter(Boolean)
                                                : [];

                                            let condition = true;

                                            if (Array.isArray(data.eventsType) && data.eventsType.length > 0) {
                                                condition = eventsTypes.some((v) => data.eventsType.includes(v));
                                            }

                                            if (condition) {
                                                if (subSubSubSubItem.place !== null) {
                                                    if (subSubSubSubItem.place.latitude && subSubSubSubItem.place.longitude) {
                                                        if (
                                                            parseInt(subSubSubItem.title) >= parseInt(data.rangeSelected.min) &&
                                                            parseInt(subSubSubItem.title) <= parseInt(data.rangeSelected.max)
                                                        ) {
                                                            // console.log(subSubSubSubItem)
                                                            tmp[mainIndex].push(subSubSubSubItem);
                                                        }
                                                    } else {
                                                        if (subSubSubSubItem.area !== null) {
                                                            if (subSubSubSubItem.area.latitude && subSubSubSubItem.area.longitude) {
                                                                if (
                                                                    parseInt(subSubSubItem.title) >= parseInt(data.rangeSelected.min) &&
                                                                    parseInt(subSubSubItem.title) <= parseInt(data.rangeSelected.max)
                                                                ) {
                                                                    subSubSubSubItem.place = null;
                                                                    // console.log(subSubSubSubItem)
                                                                    tmp[mainIndex].push(subSubSubSubItem);
                                                                }
                                                            }
                                                        }
                                                    }
                                                } else if (subSubSubSubItem.area !== null) {
                                                    if (subSubSubSubItem.area.latitude && subSubSubSubItem.area.longitude) {
                                                        if (
                                                            parseInt(subSubSubItem.title) >= parseInt(data.rangeSelected.min) &&
                                                            parseInt(subSubSubItem.title) <= parseInt(data.rangeSelected.max)
                                                        ) {
                                                            subSubSubSubItem.place = null;
                                                            // console.log(subSubSubSubItem)
                                                            tmp[mainIndex].push(subSubSubSubItem);
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    });
                                });
                            });
                        }
                        mainIndex++;
                    });

                    tmp.forEach((item) => {
                        item.forEach((subItem, subIndex) => {
                            const seeData = {
                                lat: subItem.place ? parseFloat(subItem.place.latitude.toFixed(7)) : parseFloat(subItem.area.latitude.toFixed(7)),
                                lng: subItem.place ? parseFloat(subItem.place.longitude.toFixed(7)) : parseFloat(subItem.area.longitude.toFixed(7)),
                            };

                            const agregatIndex = localEvents.findIndex((position) => position.position.lat === seeData.lat && position.position.lng === seeData.lng);

                            subItem.counter = subIndex + 1;

                            if (agregatIndex !== -1) {
                                const compositorIndex = localEvents[agregatIndex].events.findIndex((eventsArray) => eventsArray.number === subItem.localData.number);

                                if (compositorIndex !== -1) {
                                    localEvents[agregatIndex].events[compositorIndex].array.push(subItem);
                                } else {
                                    localEvents[agregatIndex].events.push({ number: subItem.localData.number, array: [subItem] });
                                }
                            } else {
                                localEvents.push({ position: { lat: seeData.lat, lng: seeData.lng }, events: [{ number: subItem.localData.number, array: [subItem] }] });
                            }
                        });
                    });
                    // console.log(localEvents)
                    setEvents(localEvents);

                    setTimeout(() => {
                        setBlur(false);
                    }, 100);
                }, 20);
            }, 250);
        }
    }, [data.events, data.rangeSelected.min, data.rangeSelected.max, data.selectedCompositors, data.historyContext, data.eventsType, setBlur]);

    useEffect(() => {
        setMapLoaded(true);
    }, [setMapLoaded]);


    useEffect(() => {
        const handleFullScreenChange = () => {
            setIsFullScreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", handleFullScreenChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullScreenChange);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            const fullScreenButton = document.querySelector(".gm-fullscreen-control");
            if (fullScreenButton) {
                if (!isFullScreen) {
                    fullScreenButton.style.marginTop = "120px";
                } else {
                    fullScreenButton.style.marginTop = "20px";
                }
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [isFullScreen]);

    return (
        <APIProvider apiKey={"AIzaSyBeRKejecsF0MW8V9d0Le2RXdA-yG1a0rE"} libraries={["marker"]} language={lang}>
            <div className={`${styles.wrapper} ${mapLoaded ? styles.loaded : ""}`}>
                <div className={`${styles.loader} ${blur ? styles.show : ""}`} />
                <div className={styles.map}>
                    <Map
                        style={{ width: "100%", height: "100%" }}
                        defaultCenter={{ lat: 52.317333, lng: 21.04115 }}
                        defaultZoom={4.6}
                        mapTypeControl={false}
                        streetViewControl={false}
                        mapId={"1d3e98f3270cb11a"}
                        scrollwheel={wheelZoom}
                        zoomControl={true}
                        onTilesLoaded={() => {
                            setMapLoaded(true);
                        }}
                    // onZoomChanged={changeZoom}
                    // options={{zoomControlOptions: {position: 6}}}
                    >
                        <Markers events={events} setWheelZoom={setWheelZoom} wheelZoom={wheelZoom} />
                    </Map>
                </div>
            </div>
        </APIProvider>
    );
}

const Markers = React.memo(({ events, setWheelZoom, wheelZoom }) => {
    const map = useMap();
    const [markers, setMarkers] = useState({});
    const clusterer = useRef();
    const apiIsLoaded = useApiIsLoaded();


    // useEffect(() => {
    //     if (!map) return;
    //     if (!apiIsLoaded) return;
    //
    //     if (!clusterer.current) {
    //         const renderer = {
    //             render: (items) => {
    //                 const content = document.createElement("div");
    //                 const composers = [];
    //
    //                 Array.from(items.markers).forEach((marker) => {
    //                     const element = marker.targetElement.children[0].children[0].children;
    //
    //                     Array.from(element).forEach((item) => {
    //                         const compositorID = item.dataset.compositor;
    //
    //                         if (compositorID) {
    //                             if (!composers.includes(compositorID)) {
    //                                 composers.push(compositorID);
    //                             }
    //                         }
    //                     });
    //                 });
    //
    //                 content.className = `${styles.container} ${styles.cluster} ${styles[`cluster${composers.length}`]}`;
    //                 composers.sort((a, b) => {
    //                     return parseInt(a) - parseInt(b);
    //                 });
    //
    //                 composers.forEach((composer) => {
    //                     const div = document.createElement("div");
    //                     div.className = `${styles.markerInGroup} ${styles[`color${composer}`]}`;
    //                     div.innerHTML = renderToString(<MarkerGroup />);
    //                     content.appendChild(div);
    //                 });
    //
    //                 return new window.google.maps.marker.AdvancedMarkerElement({ position: items.position, zIndex: 0, content: content });
    //             },
    //         };
    //
    //         clusterer.current = new MarkerClusterer({ map, renderer });
    //     }
    // }, [map, apiIsLoaded]);

    useEffect(() => {
        if (markers) {
            clusterer.current?.clearMarkers();
            clusterer.current?.addMarkers(Object.values(markers));
        }
    }, [markers]);

    const setMarkerRef = useCallback(
        (marker, key) => {
            if (marker && markers[key]) return;
            if (!marker && !markers[key]) return;

            setMarkers((prev) => {
                if (marker) {
                    return { ...prev, [key]: marker };
                } else {
                    const newMarkers = { ...prev };
                    delete newMarkers[key];
                    return newMarkers;
                }
            });
        },
        [markers]
    );

    return events
        ? events.length > 0
            ? events.map((item, index) => {
                return <Marker item={item} index={index} setMarkerRef={setMarkerRef} key={index} markers={markers} setWheelZoom={setWheelZoom} wheelZoom={wheelZoom} />;
            })
            : null
        : null;
});

const Marker = React.memo(({ item, index, setMarkerRef, markers, setWheelZoom, wheelZoom }) => {
    const map = useMap();

    const showHandle = (event, dataTag) => {
        const list = document.getElementsByClassName(styles.popup);
        const activeMarker = markers[index]

        if (activeMarker) {
            Object.values(markers).forEach((marker) => marker.style.zIndex = "0")

            const currentStyle = activeMarker.getAttribute("style") || "";
            const newStyle = currentStyle + " z-index: 10000 !important;";

            activeMarker.setAttribute("style", newStyle);
        }

        Array.from(list).forEach((item) => {
            item.classList.remove(styles.show);

            setTimeout(() => {
                item.parentElement.parentElement.parentElement.parentElement.style.zIndex = "0";
            }, 100);
        });

        setTimeout(() => {
            const button = document.querySelectorAll(`[data-id~="${dataTag}"]`)[0];

            button.parentElement.parentElement.parentElement.style.zIndex = "10";

            document.querySelectorAll(`[data-content~="${dataTag}"]`)[0].classList.add(styles.show);

            if (map) {
                const latLng = { lat: item.position.lat, lng: item.position.lng };
                map.panTo(latLng);
                map.panBy(0, -300);
            }
        }, 101);
        setTimeout(() => {
            const popup = document.querySelector(`[data-content~="${dataTag}"]`);
            if (popup) {
                popup.setAttribute("tabindex", "-1");
                popup.focus();
            }
        }, 150);
        setWheelZoom(false)
    };

    const closeHandle = () => {
        const list = document.getElementsByClassName(styles.popup);

        Array.from(list).forEach((item) => {
            item.classList.remove(styles.show);

            setTimeout(() => {
                item.parentElement.parentElement.parentElement.style.zIndex = "0";
                setWheelZoom(true)
            }, 100);
        });
    };

    return (
        <AdvancedMarker
            position={{ lat: item.position.lat, lng: item.position.lng }}
            key={index}
            className={`${styles.container} ${item.events[0].number === 5
                ? styles.historyHeight
                : item.events.length === 1 && item.events[0].array.length === 1
                    ? styles.containerMinHeight
                    : item.events.length !== 1 || item.events[0].array.length !== 1
                        ? `${styles.group} ${styles[`group${item.events.length}`]}`
                        : ""
                }`}
            ref={(marker) => {
                // if(marker) {
                //     marker.addListener('click', (event) => {
                //         showHandle(event, `${index}-${item.events[0].number}`)
                //     })
                // }
                setMarkerRef(marker, index);
            }}
        >
            {item.events.length === 1 && item.events[0].array.length === 1 ? (
                <SimpleMarker showHandle={showHandle} closeHandle={closeHandle} item={item} index={index} />
            ) : (
                <AdvMarker showHandle={showHandle} closeHandle={closeHandle} item={item} index={index} />
            )}
        </AdvancedMarker>
    );
});

const SimpleMarker = ({ item, index, showHandle, closeHandle }) => {
    let place = item.events[0].array[0].area?.alternative_names != null && item.events[0].array[0].area?.alternative_names.length > 0 ? item.events[0].array[0].area?.alternative_names.map((nameObj) => nameObj.alt_name ? nameObj.alt_name : null).join(', ') :
        item.events[0].array[0].place
            ? item.events[0].array[0].place.name
                ? item.events[0].array[0].place.name
                : item.events[0].array[0].place.area_name
            : item.events[0].array[0].area.name

    return (
        <>
            <div
                type={"button"}
                onClick={(event) => showHandle(event, `${index}-${item.events[0].number}`)}
                data-id={`${index}-${item.events[0].number}`}
                data-compositor={item.events[0].number}
                className={`${styles.marker} ${styles[`color${item.events[0].number}`]} ${item.events[0].number === 5 ? styles.history : ""}`}
            >
                {item.events[0].number !== 5 ? item.events[0].array[0].counter : <HistoryContextImage />}
            </div>
            <div className={`${styles.popup} ${styles[`color${item.events[0].number}`]}`} data-content={`${index}-${item.events[0].number}`}>
                {item.events[0].number !== 5 ? (
                    <div className={styles.left}>
                        <div className={styles.number}>{item.events[0].array[0].counter}</div>
                        <div className={styles.image} style={{ backgroundImage: `url("${item.events[0].array[0].localData.image}")` }} />
                    </div>
                ) : null}
                <div className={`${styles.right} ${item.events[0].number === 5 ? styles.history : ""}`}>
                    <div type={"button"} className={styles.close} onClick={closeHandle}>
                        <CloseImage />
                    </div>
                    {item.events[0].number !== 5 ? (
                        <p className={styles.name}>
                            {item.events[0].array[0].localData.firstName} {item.events[0].array[0].localData.lastName}
                        </p>
                    ) : (
                        <div className={styles.top}>
                            <div className={styles.number}>
                                <HistoryContextImage />
                            </div>
                            <p className={styles.text}>{translation.all.historyContext}</p>
                        </div>
                    )}
                    <div className={styles.row}>
                        {place !== '' && place !== null && place !== undefined ?
                            <div className={styles.place}>
                                <PinSmallImage />
                                <span className={styles.placeText}>
                                    {place}
                                </span>
                            </div> : null}
                        <p className={styles.date}>{`${item.events[0].array[0].human_date} ${getYear(item.events[0].array[0].date_of_beginning)}`}</p>
                    </div>
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.events[0].array[0].text }} />
                </div>
            </div>
        </>
    );
};

const AdvMarker = ({ item, index, showHandle, closeHandle, event }) => {
    return (
        <>
            {item.events.map((compositor) => {
                return (
                    <div
                        type={"button"}
                        onClick={(event) => showHandle(event, `${index}-${compositor.number}`)}
                        data-id={`${index}-${compositor.number}`}
                        data-compositor={compositor.number}
                        className={`${styles.markerInGroup} ${styles[`color${compositor.number}`]}`}
                        key={`${index}-${compositor.number}`}
                    >
                        <MarkerGroup />
                    </div>
                );
            })}
            {item.events.map((compositor) => {
                let place = compositor.array[0].area?.alternative_names != null && compositor.array[0].area?.alternative_names.length > 0 && compositor.array[0].area.alternative_names.map((nameObj) => nameObj.alt_name ? nameObj.alt_name : null).filter(name => name !== null).join(', ') ? compositor.array[0].area.alternative_names.map((nameObj) => nameObj.alt_name ? nameObj.alt_name : null).filter(name => name !== null).join(', ') :
                    compositor.array[0].place
                        ? compositor.array[0].place.name
                            ? compositor.array[0].place.name
                            : compositor.array[0].place.area_name
                        : compositor.array[0].area.name
                return (
                    <div className={`${styles.popup} ${styles.popupGroup} ${styles[`color${compositor.number}`]}`} key={`${index}-${compositor.number}`} data-content={`${index}-${compositor.number}`}>
                        <div className={`${styles.top} ${compositor.number === 5 ? styles.history : ""}`}>
                            {compositor.number !== 5 ? (
                                <div className={styles.image} style={{ backgroundImage: `url("${compositor.array[0].localData.image}")` }} />
                            ) : (
                                <div className={styles.logo}>
                                    <HistoryContextImage />
                                </div>
                            )}
                            <div className={styles.column}>
                                <p className={styles.name}>
                                    {compositor.number !== 5 ? `${compositor.array[0].localData.firstName} ${compositor.array[0].localData.lastName}` : translation.all.historyContext}
                                </p>
                                {place !== '' && place !== null && place !== undefined ?
                                    <div className={styles.place}>
                                        <PinSmallImage />
                                        <span className={styles.placeText}>
                                            {place}
                                        </span>
                                    </div> : null}
                            </div>
                            <div type={"button"} className={styles.close} onClick={closeHandle}>
                                <CloseImage />
                            </div>
                        </div>
                        <div className={styles.bottom}>
                            {compositor.array.map((event, eventIndex) => {
                                return (
                                    <div className={styles.event} key={eventIndex}>
                                        <div className={styles.row}>
                                            <div className={styles.counter}>{event.counter}</div>
                                            <p className={styles.date}>{`${event.human_date} ${getYear(event.date_of_beginning)}`}</p>
                                        </div>
                                        <div className={styles.text} dangerouslySetInnerHTML={{ __html: event.text }} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default React.memo(GoogleMap);
